module.exports = __webpack_public_path__ + "img/skate_silver.794e8391.png";